import { lazy } from 'react';

export {
  ProposalComposer,
  ProposalList,
  ProposalPipeline,
  ProposalView,
  ProposalWizardPage,
} from '../sales-pipeline/public/routes';

export const OrgChart = lazy(() =>
  import('./components/OrgChart').then((module) => ({ default: module.OrgChart }))
);

export const PendingChangesPage = lazy(() =>
  import('./pages/customer-lifecycle/PendingChangesPage').then((module) => ({
    default: module.PendingChangesPage,
  }))
);
export const NewClientOnboardingPage = lazy(() =>
  import('./pages/customer-lifecycle/NewClientOnboarding').then((module) => ({
    default: module.NewClientOnboardingPage,
  }))
);
export const ContractList = lazy(() => import('./pages/customer-lifecycle/ContractsBillingV2'));
export const ContactList = lazy(() =>
  import('./pages/customer-lifecycle/ContactList').then((module) => ({
    default: module.ContactList,
  }))
);
export const ContactDetail = lazy(() =>
  import('./pages/customer-lifecycle/ContactDetail').then((module) => ({
    default: module.ContactDetail,
  }))
);
export const ContentBlockLibrary = lazy(() =>
  import('./pages/customer-lifecycle/ContentBlockLibrary').then((module) => ({
    default: module.ContentBlockLibrary,
  }))
);
export const PricingCalculator = lazy(() =>
  import('./pages/customer-lifecycle/PricingCalculator').then((module) => ({
    default: module.PricingCalculator,
  }))
);
export const ServiceCatalog = lazy(() =>
  import('./pages/customer-lifecycle/ServiceCatalog').then((module) => ({
    default: module.ServiceCatalog,
  }))
);
export const ProfitabilityDashboard = lazy(() =>
  import('./pages/customer-lifecycle/ProfitabilityDashboard').then((module) => ({
    default: module.ProfitabilityDashboard,
  }))
);
export const ProductGapAnalysis = lazy(() =>
  import('./pages/customer-lifecycle/ProductGapAnalysis').then((module) => ({
    default: module.ProductGapAnalysis,
  }))
);
export const PriceComparison = lazy(() =>
  import('./pages/customer-lifecycle/PriceComparison').then((module) => ({
    default: module.PriceComparison,
  }))
);
export const EngagementDashboard = lazy(() =>
  import('./pages/customer-lifecycle/EngagementDashboard').then((module) => ({
    default: module.EngagementDashboard,
  }))
);
export const RenewalCalendarPage = lazy(() =>
  import('./pages/customer-lifecycle/RenewalCalendar').then((module) => ({
    default: module.RenewalCalendarPage,
  }))
);
export const QBRPage = lazy(() =>
  import('./pages/customer-lifecycle/QBRPage').then((module) => ({ default: module.QBRPage }))
);
export const QBRBuilderPage = lazy(() =>
  import('./pages/customer-lifecycle/QBRBuilderPage').then((module) => ({
    default: module.QBRBuilderPage,
  }))
);
export const RoadmapBuilderPage = lazy(() =>
  import('./pages/customer-lifecycle/RoadmapBuilderPage').then((module) => ({
    default: module.RoadmapBuilderPage,
  }))
);
export const Day1PlanPage = lazy(() =>
  import('./pages/customer-lifecycle/Day1Plan').then((module) => ({ default: module.Day1PlanPage }))
);
export const PresentationMaker = lazy(() =>
  import('./pages/customer-lifecycle/PresentationMaker').then((module) => ({
    default: module.PresentationMaker,
  }))
);
export const SatisfactionDashboard = lazy(() =>
  import('./pages/customer-lifecycle/SatisfactionDashboard').then((module) => ({
    default: module.SatisfactionDashboard,
  }))
);
export const RiskRegister = lazy(() =>
  import('./pages/customer-lifecycle/RiskRegister').then((module) => ({
    default: module.RiskRegister,
  }))
);
export const TechRoadmapList = lazy(() =>
  import('./pages/customer-lifecycle/TechRoadmapList').then((module) => ({
    default: module.TechRoadmapList,
  }))
);
export const TechRoadmapEditor = lazy(() =>
  import('./pages/customer-lifecycle/TechRoadmapEditor').then((module) => ({
    default: module.TechRoadmapEditor,
  }))
);
export const TechRoadmapTemplates = lazy(() =>
  import('./pages/customer-lifecycle/TechRoadmapTemplates').then((module) => ({
    default: module.TechRoadmapTemplates,
  }))
);

export const MSABuilder = lazy(() =>
  import('./pages/customer-lifecycle/estimator/MSABuilder').then((module) => ({
    default: module.MSABuilder,
  }))
);
export const EstimateList = lazy(() =>
  import('./pages/customer-lifecycle/estimator/EstimateList').then((module) => ({
    default: module.EstimateList,
  }))
);
export const BenchmarkCatalogue = lazy(() =>
  import('./pages/customer-lifecycle/estimator/BenchmarkCatalogue').then((module) => ({
    default: module.BenchmarkCatalogue,
  }))
);
export const MSAComparator = lazy(() =>
  import('./pages/customer-lifecycle/estimator/MSAComparator').then((module) => ({
    default: module.MSAComparator,
  }))
);
export const ServiceTerms = lazy(() =>
  import('./pages/customer-lifecycle/estimator/ServiceTerms').then((module) => ({
    default: module.ServiceTerms,
  }))
);
export const AssessorRules = lazy(() =>
  import('./pages/customer-lifecycle/estimator/AssessorRules').then((module) => ({
    default: module.AssessorRules,
  }))
);

export const RoadmapList = lazy(() =>
  import('./pages/roadmap/RoadmapList').then((module) => ({ default: module.RoadmapList }))
);
export const RoadmapEditor = lazy(() =>
  import('./pages/roadmap/RoadmapEditor').then((module) => ({ default: module.RoadmapEditor }))
);

export const PortfolioClientsPage = lazy(() => import('./pages/portfolio/ClientsPage'));
export const PortfolioClientDetailPage = lazy(() => import('./pages/portfolio/ClientDetailPage'));
export const PortfolioAnalyticsPage = lazy(() => import('./pages/portfolio/AnalyticsPage'));
export const PortfolioReportsPage = lazy(() => import('./pages/portfolio/ReportsPage'));
export const PortfolioHealthPage = lazy(() => import('./pages/portfolio/HealthPage'));
export const PortfolioWorkplaceIntelligencePage = lazy(
  () => import('./pages/portfolio/WorkplaceIntelligencePage'),
);

export const CUSTOMER_LIFECYCLE_ORGANIZATION_ROUTE_PATH = 'configure/organization';
